export const Direction = {
  FROM: "from",
  TO: "to",
} as const;

export type Direction = typeof Direction[keyof typeof Direction];
